import NotFound from 'common/NotFound';
import React from 'react'
import { RiCoupon3Line } from 'react-icons/ri';
import { formatValidTillDate } from 'utils/common';
import findSerialNumber from 'utils/findSerialNumber';

const MostUseCoupon = ({ mostUsedCoupons = [], onHide }) => {
  // console.log('mostUsedCoupons', mostUsedCoupons)
  return (
    <div className="user-management-container">
      <div className="page_title has_child">
        <h3>Top 3 Most Used Coupon Codes</h3>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="table_wrap ">
            <table className="table custom_table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Name</th>
                  <th>Details</th>
                  <th>Valid till</th>
                  <th>Type</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {mostUsedCoupons && mostUsedCoupons?.length > 0 ? (
                  mostUsedCoupons?.map((data, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{data?.name || "N/A"}</td>
                        <td>{data?.description || "N/A"}</td>
                        <td>{formatValidTillDate(data?.validFrom, data?.validTo) || "N/A"}</td>
                        <td>{data?.type || "N/A"}</td>
                        <td>{data?.amount || "N/A"}</td>
                      </tr>
                    );
                  })
                ) : (
                  <NotFound
                    cols={6}
                    msg={"Most Used Coupon Codes not found"}
                    onHide={onHide}
                    icon={<RiCoupon3Line />}
                  />
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MostUseCoupon